import { BaseComponent } from '@tfagency/shared/util';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { RouteConstants } from '../shared/constants/route.constants';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'tfagency-home',
  imports: [TranslateModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent extends BaseComponent implements OnInit, OnDestroy {
  constructor(
    private oauthService: OAuthService,
    private router: Router,
  ) {
    super();
  }

  override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    const isAuthenticated = await this.oauthService.loadDiscoveryDocumentAndLogin();
    this.oauthService.setupAutomaticSilentRefresh();
    if (isAuthenticated) {
      this.router.navigate([`/${RouteConstants.DASHBOARD_ROUTE}`]);
    }
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
